module.exports = "<h1 mat-dialog-title>Confirmación</h1>\r\n<div mat-dialog-content>\r\n    <p>{{mensaje}}</p>\r\n</div>\r\n<div mat-dialog-actions>\r\n    <button mat-button (click)=\"cerrarDialogo()\">No</button>\r\n    <button mat-button (click)=\"confirmado()\" cdkFocusInitial>Sí</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/REPO/FacturacionWeb/src/app/main/content/DialogConfirmacion/dialogo-confirmacion.component.html
// module id = ../../../../../src/app/main/content/DialogConfirmacion/dialogo-confirmacion.component.html
// module chunks = main